import * as React from 'react';
import type { JSX } from 'react';
import { UIHeading1 } from '@cian/ui-kit';
import { IconPlaceholderBuilder24 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './BuilderCallReasons.css';

const QUESTIONS = [
  'Какие есть варианты отделки?',
  'Есть акции и скидки?',
  'С каким банками работаете?',
  'Может, на других этажах есть квартиры дешевле?',
  'Когда сдаётся дом?',
];

export interface IBuilderCallReasonsProps {
  contactsButton: JSX.Element;
  flatViewOrderButton: JSX.Element;
  title: string;
}

export const BuilderCallReasons: React.FC<IBuilderCallReasonsProps> = ({
  contactsButton,
  flatViewOrderButton,
  title,
}) => {
  return (
    <div className={styles['builder-call-reasons']} data-testid="BuilderCallReasons">
      <div className={styles['content']}>
        <div className={styles['header']}>
          <div className={styles['icon']}>
            <IconPlaceholderBuilder24 color="icon-main-default" />
          </div>
          <UIHeading1>{title}</UIHeading1>
        </div>
        <div className={styles['reasons']} data-testid="BuilderCallReasonList">
          {QUESTIONS.map((question, index) => (
            <div key={index} className={styles['reason']}>
              {question}
            </div>
          ))}
        </div>
        <div className={styles['actions']}>
          {contactsButton}
          {flatViewOrderButton}
        </div>
      </div>
    </div>
  );
};
